import React, { useEffect, useState, useRef } from "react";
import styles from "./StatsSection.module.css";

const stats = [
  { 
    label: "Projects Completed", 
    value: 100, 
    icon: "🏛️" 
  },
  { 
    label: "Years Excellence", 
    value: 25, 
    icon: "⏱️" 
  },
  { 
    label: "Distinguished Clients", 
    value: 95, 
    icon: "👑" 
  }
];

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const [counters, setCounters] = useState(stats.map(() => 0));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000; // Animation duration in ms
    const interval = 20; // Update interval in ms
    const steps = duration / interval;

    const incrementCounters = () => {
      setCounters(prev =>
        prev.map((counter, idx) => {
          const target = stats[idx].value;
          const increment = target / steps;
          const newValue = Math.min(counter + increment, target);
          return newValue;
        })
      );
    };

    const timer = setInterval(() => {
      incrementCounters();
      
      // Check if all counters reached their targets
      if (counters.every((counter, idx) => counter >= stats[idx].value - 0.1)) {
        clearInterval(timer);
        // Set exact final values
        setCounters(stats.map(stat => stat.value));
      }
    }, interval);

    return () => clearInterval(timer);
  }, [isVisible, counters]);

  return (
    <section ref={sectionRef} className={styles.statsSection}>
      <div className={styles.decorativeTop}></div>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.title}>Our Distinguished Legacy</h2>
          <p className={styles.subtitle}>Exceptional stonework craftsmanship since 2000</p>
        </div>
        
        <div className={styles.statsGrid}>
          {stats.map((stat, idx) => (
            <div 
              key={idx} 
              className={`${styles.statCard} ${isVisible ? styles.animate : ''}`}
              style={{ animationDelay: `${idx * 150}ms` }}
            >
              <div className={styles.statIcon}>{stat.icon}</div>
              <div className={styles.statValue}>
                {Math.round(counters[idx])}
                <span>+</span>
              </div>
              <div className={styles.divider}></div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.decorativeBottom}></div>
    </section>
  );
};

export default StatsSection;